import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import NProgress from "nprogress";

import ShipperRoutes from "./shipper-routes";
import RootRoutes from "./root-routes";
import PortRoutes from "./port-routes";
import NimasaAgentRoutes from "./nimasa-agent-routes";
import AdminRoutes from "./admin-routes"

Vue.use(Router);

const router = new Router({
  routes: [...RootRoutes, ...ShipperRoutes, ...PortRoutes, ...NimasaAgentRoutes, ...AdminRoutes]
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    NProgress.start();
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
